import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # Category
 *
 * Category을 설명하세요.
 * categoryInfoList: 언어별 카테고리 info
 * Category: 카테고리
 *
 */

// categoryInfoList: 언어별 카테고리 info
export const CategoryInfoList = types.model('CategoryInfoList', {
  langCd: types.maybeNull(types.string),
  categoryNm: types.optional(types.string, ''),
  mainTitle: types.optional(types.string, ''),
  subTitle: types.optional(types.maybeNull(types.string), ''),
  mainDesc: types.optional(types.maybeNull(types.string), ''),
  subDesc: types.optional(types.maybeNull(types.string), ''),
  pipeline: types.optional(types.maybeNull(types.string), ''),
  pipelineList: types.optional(types.maybeNull(types.string), ''),
  categoryInfoSid: types.optional(types.maybeNull(types.number), null),
});
export interface ICategoryInfoList extends Instance<typeof CategoryInfoList> {}
export const categoryInfoList = () => types.optional(CategoryInfoList, {} as ICategoryInfoList);

// Category: 카테고리
export const Category = types
  .model('Category')
  // --------------------------------------------------------------------------
  .props({
    categoryPsid: types.optional(types.maybeNull(types.number), 0),
    categorySid: types.optional(types.number, 0),
    useYn: types.optional(types.boolean, false),
    ordr: types.optional(types.number, 0),
    thumbnailPath: types.optional(types.maybeNull(types.string), ''),
    bgDesktopPath: types.optional(types.maybeNull(types.string), ''),
    bgMobilePath: types.optional(types.maybeNull(types.string), ''),
    ctgyDpTypeCd: types.maybeNull(CodeModel),
    delYn: types.optional(types.boolean, false),
    categoryInfoList: types.optional(types.maybeNull(types.array(CategoryInfoList)), []),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    // 트리 구조를 위한 타입 추가
    children: types.maybeNull(types.optional(types.array(types.late((): any => Category)), [])),
  })
  .volatile(() => ({
    thumbnail: types.maybeNull(types.frozen()),
    desktopImageFile: types.maybeNull(types.frozen()),
    mobileImageFile: types.maybeNull(types.frozen()),
  }))
  .views((self) => ({
    // 자식 여부 확인
    hasChildren() {
      return self.children && self.children.length > 0;
    },
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TCategory = Instance<typeof Category>;
type TCategorySnapshot = SnapshotOut<typeof Category>;

export interface ICategory extends TCategory {}
export type TCategoryKeys = keyof TCategorySnapshot & string;
export interface ICategorySnapshot extends TCategorySnapshot {}
export const createCategory = () => types.optional(Category, {} as TCategory);

// TreeNode를 위한 모델 정의
export const CategoryTreeNode = types
  .model('CategoryTreeNode')
  // --------------------------------------------------------------------------
  .props({
    label: types.optional(types.string, ''), // 카테고리 이름
    value: types.union(types.number, types.string), // 고유 식별자
    children: types.optional(types.array(types.late((): any => CategoryTreeNode)), []), // 재귀적 children
  })
  .actions(withSetPropAction);

export interface ICategoryTreeNode extends Instance<typeof CategoryTreeNode> {}
export const createTreeCategory = () => types.optional(CategoryTreeNode, {} as ICategoryTreeNode);
